<template>
  <div class="content" v-if="configuration && configuration.showFind">
    <div class="wrapper">
      <h1>{{messages.findAppointmentButton}}</h1>
      <div class="info-text" tabindex="-1">{{messages.searchInfoText}}</div>
      <v-form ref="form" v-model="valid">
        <div v-for="(field, index) in searchFields" :key="index" class="fields-wrapper">
          <phone-field
            :key="componentKey"
            v-if="field.name === 'Phone' && field.f === 1"
            @phone-verified="phoneVerified"
            :field="field"
            :read-only="false"
            :show-autocomplete="true"
            :show-appointments="false"
            ref="phoneFieldRef"
            @is-phone-valid="setPhoneValidity"
          ></phone-field>
          <birth-picker
            v-if="field.name === 'DOB' && field.f === 1"
            :field="field"
            @birth-selected="birthSelected"
          ></birth-picker>
          <v-text-field tabindex="0"
            class="input-field search"
            :id="field.name"
            height="48"
            outline
            :required="field.m === 1 ? true: false"
            v-if="field.f === 1 && field.name !== 'Phone' && field.name !== 'DOB'"
            :autocomplete="field.name === 'BookingId' ? 'off':'on'"
            v-model="userInput[field.name]"
            :type="field.name === 'BookingId' ? 'number' : 'text'"
            ref="firstFieldNameRef"
          >
            <div for="verification-code" slot="label">{{messages[field.name]}}</div>
          </v-text-field>
        </div>
        <v-alert role="alert" :value="noAppointments" type="error">{{errorMessage}}</v-alert>
        <!--<div class="info-text" v-if="noAppointments">{{messages.noAppointmentsFound}}</div>-->
        <v-btn
          :ripple="false"
          text
          class="submit search"
          @click="onSearch"
          :disabled="status || (!verified && configuration.sendConfirm) || (phoneIsSearchable && !isPhoneValid)"
          id="searchButton"
          ref="searchBtnRef"
        >
          <div v-if="!status">{{messages.searchButtonText}}</div>
          <v-progress-circular role="progressbar" indeterminate class="progress-bar" v-else></v-progress-circular>
        </v-btn>
      </v-form>
      <appointment-list
        :key="componentKey"
        :existing-appointments="appointmentList"
        :display-url="true"
      ></appointment-list>
      <vue-recaptcha
        v-if="configuration.captchaEnabled"
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        size="invisible"
        badge="inline"
        :sitekey="configuration.captchaSiteKey"
      ></vue-recaptcha>
    </div>
    <v-btn
      :ripple="false"
      class="submit back"
      text
      v-if="messages.startPageFindButtonText"
      @click="backToStart"
      id="backToStartButton"
    >{{messages.startPageFindButtonText}}</v-btn>
  </div>
</template>

<script>
import RestService from '../services/restService'
import AppointmentList from '../components/AppointmentList'
import VueRecaptcha from 'vue-recaptcha'
import PhoneField from '../components/PhoneField'
import BirthPicker from '../components/BirthPicker'
import { mapActions, mapState, mapGetters } from 'vuex'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'FindBooking',
  mixins: [RestService],
  props: [
    'urlParams',
    'startPage',
    'queryParams'
  ],
  components: {
    VueRecaptcha,
    AppointmentList,
    PhoneField,
    BirthPicker
  },
  data: () => ({
    componentKey: 0,
    searchFields: [],
    appointmentList: [],
    noAppointments: false,
    userInput: {
      Email: '',
      Phone: '',
      FirstName: '',
      LastName: '',
      CustRef: '',
      AppRef: '',
      DOB: ''
    },
    status: false,
    verified: false,
    valid: true,
    formattedPhone: null,
    errorMessageElement: '',
    reCaptchaVerified: false,
    isPhoneValid: true,
    phoneIsSearchable: false
  }),
  computed: {
    ...mapActions([
      'setAppMode'
    ]),
    ...mapState([
      'funcDebug',
      'configuration',
      'messages',
      'selectedLanguage'
    ]),
    ...mapGetters({
      getSecurityToken: 'getSecurityToken'
    }),
    errorMessage () {
      return this.errorMessageElement ? this.messages[this.errorMessageElement] : ''
    }
  },
  methods: {
    ...mapActions([
      'resetBookingStore'
    ]),
    forceReRender () {
      this.componentKey++
    },
    setPhoneValidity (validity) {
      this.isPhoneValid = validity
    },
    backToStart () {
      if (this.funcDebug) console.log('FindBooking:methods:backToStart')
      // configuration is not used by intention and resolves backend issues
      // this method is only called if the appmode is new, as otherwise the button is hidden
      // check for admin backUrl

      this.resetBookingStore().then(() => {
        if (this.messages && this.messages.startPageFindUrl) {
          var url = this.messages.startPageFindUrl ? this.messages.startPageFindUrl : ''
          if (url) {
            location.replace(url)
          } else {
            let routingObj = {
              name: this.startPage,
              params: this.urlParams,
              query: this.queryParams
            }
            eventHub.$emit('reload-configuration', routingObj)
          }
        } else {
          let routingObj = {
            name: this.startPage,
            params: this.urlParams,
            query: this.queryParams
          }
          eventHub.$emit('reload-configuration', routingObj)
        }
      })
    },
    birthSelected (birth) {
      if (this.funcDebug) console.log('FindBooking:methods:birthSelected')
      this.userInput.DOB = birth
    },
    phoneVerified (verified, formattedPhone, readOnly) {
      if (this.funcDebug) console.log('FindBooking:methods:phoneVerified')
      this.formattedPhone = formattedPhone
      this.verified = verified
      if (this.verified) {
        this.setNextFocus()
      }
    },
    setNextFocus () {
      // set focus after phone verification
      var el = this.$refs.form.$el
      var idx
      var found
      for (var i = 0; i < el.length; i++) {
        if (el[i].id === 'Phone') {
          idx = i + 1
          found = true
        }
        if (el[i].id === 'phoneCodeButton') {
          idx = i
          found = true
        }
      }
      if (found === true && (this.configuration.sendConfirm && this.verified)) {
        this.$nextTick(() => {
          this.$refs.form.$el[idx].focus()
        })
      }
    },
    onSearch () {
      if (this.funcDebug) console.log('FindBooking:methods:onSearch')
      this.appointmentList = []
      if (this.$refs.form.validate() && ((this.phoneIsSearchable && this.isPhoneValid) || !this.phoneIsSearchable)) {
        var _this = this
        this.status = true
        if ((this.verified && this.configuration.sendConfirm) || !this.configuration.sendConfirm) {
          if (this.configuration.captchaEnabled && !this.reCaptchaVerified) {
            this.$refs.recaptcha.execute()
          } else {
            this.userInput.formattedPhone = this.formattedPhone
            this.findAppointment(
              this.userInput,
              false,
              this.getSecurityToken,
              true
            ).then(response => {
              _this.appointmentList = response.data
              if (response.data.length === 0) {
                _this.noAppointments = true
                _this.errorMessageElement = 'noAppointmentsFound'
                eventHub.$emit('appointments-found', '')
              } else {
                if (response.data[0].errorMessage) {
                  _this.noAppointments = true
                  if (response.data[0].errorMessage === 'ERROR_CUSTOMERS_MULTIPLE') {
                    _this.errorMessageElement = 'findAppointmentErrorMultipleCustomersFound'
                  } else if (response.data[0].errorMessage === 'ERROR_SESSION_VIOLATION') {
                    _this.errorMessageElement = 'findAppointmentErrorSessionViolation'
                  } else if (response.data[0].errorMessage === 'ERROR_NOT_ENOUGH_SEARCH_FIELDS') {
                    _this.errorMessageElement = 'findAppointmentFieldsMissing'
                  } else {
                    _this.errorMessageElement = 'findAppointmentErrorGeneralMessage'
                  }
                  _this.appointmentList = []
                } else {
                  _this.noAppointments = false
                  eventHub.$emit('appointments-found', 'foundAppointmentsInfoText')
                }
              }
              _this.status = false
            })
          }
        }
      }
    },
    onCaptchaVerified (recaptchaToken) {
      if (this.funcDebug) console.log('FindBooking:methods:onCaptchaVerified')
      var _this = this
      this.recaptchaToken = recaptchaToken
      this.userInput.formattedPhone = this.formattedPhone
      this.reCaptchaVerified = true
      this.findAppointment(
        this.userInput,
        recaptchaToken,
        this.getSecurityToken,
        true
      ).then(response => {
        _this.appointmentList = response.data
        if (response.data.length === 0) {
          _this.noAppointments = true
          _this.errorMessageElement = 'noAppointmentsFound'
          eventHub.$emit('appointments-found', '')
        } else {
          if (response.data[0].errorMessage) {
            _this.noAppointments = true
            if (response.data[0].errorMessage === 'ERROR_CUSTOMERS_MULTIPLE') {
              _this.errorMessageElement = 'findAppointmentErrorMultipleCustomersFound'
            } else if (response.data[0].errorMessage === 'ERROR_SESSION_VIOLATION') {
              _this.errorMessageElement = 'findAppointmentErrorSessionViolation'
            } else if (_this.existingAppointments[0].errorMessage === 'ERROR_NOT_ENOUGH_SEARCH_FIELDS') {
              _this.errorMessageElement = 'findAppointmentFieldsMissing'
            } else {
              _this.errorMessageElement = 'findAppointmentErrorGeneralMessage'
            }
            _this.appointmentList = []
          } else {
            _this.noAppointments = false
            eventHub.$emit('appointments-found', 'foundAppointmentsInfoText')
          }
        }
        _this.status = false
      })
    },
    onCaptchaExpired () {
      if (this.funcDebug) console.log('FindBooking:methods:onCaptchaExpired')
      this.$refs.recaptcha.reset()
    },
    // Set focus to first interactive element
    setfocus (data) {
      if (this.$route.name === 'search') {
        this.$nextTick(() => { this.$refs.firstFieldNameRef[0].focus() })
      }
    },
    reset () {
      if (this.$refs.form) this.$refs.form.reset()
      this.errorMessageElement = ''
      this.noAppointments = false
      this.appointmentList = []
      this.isPhoneValid = false
      this.valid = false
      this.verified = false
      this.forceReRender()
      this.resetBookingStore()
    }
  },
  mounted () {
    if (this.funcDebug) console.log('FindBooking:mounted')
    if (!this.configuration.showFind) {
      this.backToStart()
    } else {
      this.searchFields = this.configuration.uiFields
      if (this.searchFields.Phone && this.searchFields.Phone.f === 1) {
        this.phoneIsSearchable = true
      }
      if (this.configuration.sendConfirm) {
        this.verified = false
      } else {
        this.verified = true
      }
    }
    // Event Bus: receive route name to set focus to first interactive element
    eventHub.$on('focusFirstEvent', (payload) => { this.setfocus(payload) })
    eventHub.$on('reset-find-booking', (payload) => { this.reset() })
  }
}
</script>

<style>
form .submit.search.v-btn.v-btn--text.theme--light {
  min-width: 100px;
  height: 52px;
}
</style>
